<template>
  <LegalPage title="Frequently Asked Questions">
    <h2>Orders</h2>

    <h3>How do I place an order?</h3>
    <p>
      Browse or search for the books you want, add them to your cart, and proceed
      to checkout. Enter your delivery details, choose a payment method, and
      confirm your order. You will receive an order confirmation once it is
      placed.
    </p>

    <h3>Are your books printed on order?</h3>
    <p>
      Yes. Many of our titles are printed specifically for your order. This lets
      us offer a wide range of books, but it also means printing takes a little
      time before dispatch, and general returns are not accepted. Please review
      your order carefully before confirming.
    </p>

    <h3>Can I cancel or change my order?</h3>
    <p>
      Because printing begins soon after your order is confirmed, changes or
      cancellations may only be possible if printing has not yet started. Please
      contact us as soon as possible if you need to make a change.
    </p>

    <h2>Payment</h2>

    <h3>What payment methods do you accept?</h3>
    <p>
      We accept bKash, Nagad, and other methods shown at checkout, as well as
      cash on delivery where available.
    </p>

    <h3>Is it safe to pay online?</h3>
    <p>
      Yes. Payments are processed securely through our trusted payment partners.
      We do not store your full card or mobile wallet credentials.
    </p>

    <h2>Delivery</h2>

    <h3>How long will delivery take?</h3>
    <p>
      After printing and preparation (typically 2–4 business days), delivery
      usually takes 2–3 business days inside Dhaka and 3–5 business days outside
      Dhaka. See our
      <router-link to="/delivery-policy">Delivery Policy</router-link> for full
      details.
    </p>

    <h3>How much are delivery charges?</h3>
    <p>
      Delivery charges depend on your location and are shown clearly at checkout
      before you confirm your order.
    </p>

    <h3>How can I track my order?</h3>
    <p>
      You can check your order status any time from the
      <router-link to="/orders">My Orders</router-link> section of your account.
    </p>

    <h2>Returns &amp; Replacements</h2>

    <h3>Can I return a book?</h3>
    <p>
      As our books are printed on order, we do not accept general returns.
      However, if your book has a printing defect, we will replace it free of
      charge.
    </p>

    <h3>What if my book has missing pages or a misprint?</h3>
    <p>
      If you find any missing pages or a misprint, we will provide you with a
      fresh copy at no additional charge and collect the faulty copy from you.
      Please contact us within 7 days of receiving your order. See our
      <router-link to="/return-refund-policy">Return &amp; Refund Policy</router-link>
      for details.
    </p>

    <h2>Account &amp; Support</h2>

    <h3>Do I need an account to order?</h3>
    <p>
      Creating an account makes it easier to track orders and check out faster,
      and we recommend it for the best experience.
    </p>

    <h3>How do I contact you?</h3>
    <p>
      You can reach us through our
      <router-link to="/contact">Contact page</router-link>, by phone at
      <a href="tel:+8801711086468">+880 1711 086 468</a>, or by email at
      <a href="mailto:nilkhetdotcom@gmail.com">nilkhetdotcom@gmail.com</a>. We
      offer 24/7 support.
    </p>
  </LegalPage>
</template>

<script>
import LegalPage from "@/components/LegalPage.vue";

export default {
  name: "FaqPage",
  components: { LegalPage },
};
</script>
